export const categories = [
    {
        id: 1,
        name: "New Arrival",
        image: "/assets/images/category-01.jpg",
    },
    {
        id: 2,
        name: "Cigar & Cig",
        image: "/assets/images/category-02.jpg",
    },
    {
        id: 3,
        name: "Spirits",
        image: "/assets/images/category-03.jpg",
    },
    {
        id: 4,
        name: "Wines",
        image: "/assets/images/category-04.jpg",
    },
    {
        id: 5,
        name: "Sake",
        image: "/assets/images/category-05.jpg",
    },
    {
        id: 6,
        name: "Beer",
        image: "/assets/images/category-06.jpg",
    },
    {
        id: 7,
        name: "RTD & Mead",
        image: "/assets/images/category-07.jpg",
    },
    {
        id: 8,
        name: "Craft Beers",
        image: "/assets/images/category-08.jpg",
    },
];